/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InventoryRegistryDTO } from './InventoryRegistryDTO';
import {
    InventoryRegistryDTOFromJSON,
    InventoryRegistryDTOFromJSONTyped,
    InventoryRegistryDTOToJSON,
} from './InventoryRegistryDTO';
import type { Pageable } from './Pageable';
import {
    PageableFromJSON,
    PageableFromJSONTyped,
    PageableToJSON,
} from './Pageable';
import type { Sort } from './Sort';
import {
    SortFromJSON,
    SortFromJSONTyped,
    SortToJSON,
} from './Sort';

/**
 * 
 * @export
 * @interface InventoryRegistryPageDTO
 */
export interface InventoryRegistryPageDTO {
    /**
     * 
     * @type {Array<InventoryRegistryDTO>}
     * @memberof InventoryRegistryPageDTO
     */
    content?: Array<InventoryRegistryDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof InventoryRegistryPageDTO
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InventoryRegistryPageDTO
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof InventoryRegistryPageDTO
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryRegistryPageDTO
     */
    numberOfElements?: number;
    /**
     * 
     * @type {Pageable}
     * @memberof InventoryRegistryPageDTO
     */
    pageable?: Pageable;
    /**
     * 
     * @type {number}
     * @memberof InventoryRegistryPageDTO
     */
    size?: number;
    /**
     * 
     * @type {Sort}
     * @memberof InventoryRegistryPageDTO
     */
    sort?: Sort;
    /**
     * 
     * @type {number}
     * @memberof InventoryRegistryPageDTO
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof InventoryRegistryPageDTO
     */
    totalPages?: number;
}

/**
 * Check if a given object implements the InventoryRegistryPageDTO interface.
 */
export function instanceOfInventoryRegistryPageDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InventoryRegistryPageDTOFromJSON(json: any): InventoryRegistryPageDTO {
    return InventoryRegistryPageDTOFromJSONTyped(json, false);
}

export function InventoryRegistryPageDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): InventoryRegistryPageDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'content': !exists(json, 'content') ? undefined : ((json['content'] as Array<any>).map(InventoryRegistryDTOFromJSON)),
        'first': !exists(json, 'first') ? undefined : json['first'],
        'last': !exists(json, 'last') ? undefined : json['last'],
        'number': !exists(json, 'number') ? undefined : json['number'],
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'pageable': !exists(json, 'pageable') ? undefined : PageableFromJSON(json['pageable']),
        'size': !exists(json, 'size') ? undefined : json['size'],
        'sort': !exists(json, 'sort') ? undefined : SortFromJSON(json['sort']),
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'totalPages': !exists(json, 'totalPages') ? undefined : json['totalPages'],
    };
}

export function InventoryRegistryPageDTOToJSON(value?: InventoryRegistryPageDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'content': value.content === undefined ? undefined : ((value.content as Array<any>).map(InventoryRegistryDTOToJSON)),
        'first': value.first,
        'last': value.last,
        'number': value.number,
        'numberOfElements': value.numberOfElements,
        'pageable': PageableToJSON(value.pageable),
        'size': value.size,
        'sort': SortToJSON(value.sort),
        'totalElements': value.totalElements,
        'totalPages': value.totalPages,
    };
}

